<template>
    <frm-modal-component
        ref="modal"
        data-testid="cov-check-result-modal"
        save-only
        :save-label="t('base.close')"
        @save="$refs.modal.closeModal()"
    >
        <template #header>
            {{ t('patient.cov-check.result-modal.title', { patient: patientNameAndBirthdate }) }}
        </template>

        <dl class="information-list" data-testid="cov-check-result-details">
            <dt class="information-list__title">
                {{ t('patient.cov-check.result-modal.found_policies') }}:
            </dt>
            <dd class="information-list__description">
                {{ foundPolicies }}
            </dd>
            <dt class="information-list__title">
                {{ t('patient.cov-check.result-modal.created_policies') }}:
            </dt>
            <dd class="information-list__description ">
                {{ createdPolicies }}
            </dd>
            <dt class="information-list__title">
                {{ t('patient.cov-check.result-modal.updated_policies') }}:
            </dt>
            <dd class="information-list__description ">
                {{ updatedPolicies }}
            </dd>
            <dt class="information-list__title">
                {{ t('patient.cov-check.result-modal.updated_packages') }}:
            </dt>
            <dd class="information-list__description ">
                {{ updatedPackages }}
            </dd>
        </dl>

        <hr class="form-separator">

        <strong>
            {{ t('patient.cov-check.result-modal.active_policies') }}:
        </strong>

        <ul class="active-policies" data-testid="cov-check-active-policies">
            <li v-for="(policy, index) in activePolicies" :key="index">
                {{ policy }}
            </li>
        </ul>

        <template v-if="showPoliciesLink" #buttons>
            <a class="button button--text button--grouped policies-link"
               :href="policiesUrl"
               data-testid="cov-check-view-policies-link"
            >
                <span>
                    {{ t('patient.cov-check.result-modal.view_policies', { patient: patientName }) }}
                </span>
            </a>
        </template>
    </frm-modal-component>
</template>

<script>

import i18n from '../i18n';

export default {
    props: {
        activePolicies: {
            type: Array,
            required: true,
        },

        createdPolicies: {
            type: Number,
            required: true,
        },

        foundPolicies: {
            type: Number,
            required: true,
        },

        updatedPackages: {
            type: Number,
            required: true,
        },

        updatedPolicies: {
            type: Number,
            required: true,
        },

        policiesUrl: {
            type: String,
            required: true,
        },

        patientName: {
            type: String,
            required: true,
        },

        patientNameAndBirthdate: {
            type: String,
            required: true,
        },

        showPoliciesLink: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        t() {
            // $t() cannot be used in a modal component, because it is rendered outside the Vue app. Therefore we use i18n.t() directly.
            return i18n.t(...arguments);
        },
    },
};
</script>

<style scoped lang="scss">

.active-policies {
    margin-bottom: 0;
}

.policies-link {
    span {
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

</style>
